
export enum InputType {
  active = 0, // 主动发送
  unActive = 1, // 非主动发送
}

export enum MessageSourceFrom {
  default = 0, // 默认没有任何引导，代表用户主动输入消息
  guess_question = 1, // 问题推荐
  consult_btn = 2, // 引导卡片的咨询引导
  retain_popup = 3, // 挽留弹窗
  quick_reply = 4, // 一键回复
}

// 心跳类型
export enum HeartBeatType {
  heat_beat = 1, // 心跳
  page_open = 2, // 进入页面
  chat_info = 3, // 会话创建
  chat_end = 4, // 会话关闭
  page_close = 5 // 页面关闭
}

// 会话激活状态
export enum ChatActivate {
  active = 1, // 激活
  un_active = 2 // 未激活
}
